// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1BKzS","inner":"Form_inner__2K4Ck","range":"Form_range__1UomU","name":"Form_name__3gsFM","actions":"Form_actions__p6KHc"};